import React, { Fragment, useEffect } from "react";
import { FaRegCircle } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import { moduleitemCompDTO } from "../../../typings/uicomponents";
import { Moduleicon, moreIcon } from "../../../constant/import";
import Button from "../Button";
import { onInstallModule, onRemove } from "../../../services/modules";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useModulesHook } from "../../../hooks/useModulesHook";
import { LuMoreVertical } from "react-icons/lu";
import { MdOutlineMoreVert } from "react-icons/md";
import { Menu, Transition } from "@headlessui/react";

const ModuleInstallItem: //  React.FC<moduleitemCompDTO>
any = (props: any) => {
  const { onSelected, moduleName, features, id } = props.item;
  const { config, SelectedOrg } = useStateGetter();

  const { InstallModule, isintalled, Deactivate, Remove } = useModulesHook();

  return (
    <div
      onClick={onSelected}
      className="rounded-[16px] relative px-2  border flex  item-center  justify-center border-gray-200 mt-4"
    >
      <img className={"w-[80] h-[80px] self-center"} src={Moduleicon} />

      <div className="p-2 w-[60%]">
        <p className=" cursor-pointer text-sm text-gray-700 font-medium ">
          {moduleName}
        </p>
        <p className=" cursor-pointer text-smtext-bl text-gray-700 font-light text-xs truncate ">
          {features}
        </p>
        {!isintalled(id) && (
          <Button
            width={130}
            disabled={false}
            text="Install"
            onBtnClick={async () => {
              await InstallModule(id);
            }}
          />
        )}

        {isintalled(id) && (
          <Button
            OverideStyle={"text-gray-600"}
            style={"bg-transparent text-black"}
            width={130}
            disabled={true}
            text="Installed"
            onBtnClick={async () => {}}
          />
        )}
      </div>

      {isintalled(id) && (
        <Menu as="div" className="  self-center w-[10%]">
          <div>
            <Menu.Button className=" p-1 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-neutral-200">
             <LuMoreVertical/>
           </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="origin-top-right z-10 absolute right-0 mt-2 w-48 rounded-[8px] shadow-md p-1 bg-white ring-1 ring-opacity-5 focus:outline-none">
              <Menu.Item>
                <p
                  onClick={async () => {
                    await Deactivate(id);
                  }}
                  className="text-semibold text-textbg text-sm cursor-pointer p-2 hover:bg-gray-100 "
                >
                  Deactivate
                </p>
              </Menu.Item>
              <Menu.Item>
                <p
                  onClick={async () => {
                    await Remove(id);
                  }}
                  className="text-semibold text-textbg text-sm p-2 cursor-pointer hover:bg-gray-100 "
                >
                  Remove
                </p>
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu>
      )}
    </div>
  );
};

export default ModuleInstallItem;
